<template>
  <div class="col-md-12 project-list">
    <div class="card">
      <div class="row">
        <div class="col-12 d-flex align-items-center">
          <div class="input-group me-3" style="max-width: 600px">
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por formulario, descripción o usuario..."
              v-model="searchQuery"
              @input="onSearchChange"
            />
            <button
              v-if="searchQuery"
              class="btn btn-outline-secondary"
              type="button"
              @click="clearSearch"
              title="Limpiar búsqueda"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="dropdown d-flex justify-content-end">
            <button
              class="btn dropdown-toggle"
              style="width: 150px"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa fa-filter me-1"></i>
              {{ selectedFilter }}
            </button>
            <ul class="dropdown-menu">
              <li v-for="filter in filterOptions" :key="filter">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="onFilterChange(filter)"
                  :class="{ active: selectedFilter === filter }"
                >
                  {{ filter }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  currentView: {
    type: String,
    default: "todos-formularios",
  },
});

const emit = defineEmits([
  "formCreated",
  "viewChanged",
  "searchChanged",
  "filterChanged",
]);

const searchQuery = ref("");
const selectedFilter = ref("Sin Filtro");

const filterOptions = [
  "Sin Filtro",
  "TODOS",
  "SER - PRIMARIA",
  "SER - SECUNDARIA",
  "SEA - ALTERNATIVA",
  "SEA - ESPECIAL",
  "ESFM",
  "MAESTRO - REGULAR",
  "MAESTRO - ALTERNATIVA",
  "MAESTRO - ESPECIAL",
  "MAESTRO - ESFM",
];

const onSearchChange = () => {
  emit("searchChanged", searchQuery.value);
};

const onFilterChange = (filter) => {
  selectedFilter.value = filter;
  emit("filterChanged", filter);
};

const clearSearch = () => {
  searchQuery.value = "";
  emit("searchChanged", "");
};

watch(
  () => props.currentView,
  (newView) => {
    searchQuery.value = "";
    selectedFilter.value = "Sin Filtro";
  }
);
</script>
